module.exports = __webpack_public_path__ + "img/industry-bg.21b603c2.png";